/**
 * Custom JS
 */

(function($) {
    $(document).ready(function () {

        var queryString = window.location.search;
        var paramsObject = {};
        
        if(queryString) {
            var rawParams = queryString.substring(1).split('&');

            $.each(rawParams, function(index, param) {
                var paramPair = param.split('=');
                if (paramPair.length === 2) {
                    paramsObject[decodeURIComponent(paramPair[0])] = decodeURIComponent(paramPair[1]);
                }
            });
        }

        if (paramsObject['name'] == 'tour') {
            $('.tour-section').fadeIn('slow');
        } else if (paramsObject['name'] == 'videos') {
            $('.video-section').fadeIn('slow');
        } else if (paramsObject['name'] == 'music') {
            $('.music-section').fadeIn('slow');
        }

        $('.richtext-with-menu .menu-item').each(function() {
            $(this).on('click', function() {
                var menuName = $(this).data('menu');
                if (menuName == 'tour') {
                    $('.tour-section').fadeIn('slow');
                } else if (menuName == 'music') {
                    $('.music-section').fadeIn('slow');
                } else if (menuName == 'videos') {
                    $('.video-section').fadeIn('slow');
                }
            });
        });

        /**
         * Tour popup
         */

        $('.tour-section .tab-item').each(function() {
            $(this).on('click', function() {
                $('.tour-section .tour-item-wrapper').hide();
                $('.tour-section .tab-item').removeClass('selected');
                $(this).addClass('selected');

                if ($(this).hasClass('tab_1')) {
                    $('.tour-1-wrapper').show();
                } else if ($(this).hasClass('tab_2')) {
                    $('.tour-2-wrapper').show();
                } else {
                    $('.tour-3-wrapper').show();
                }
            });
        });

        $('.tour-section .close-button').on('click', function() {
            $('.tour-section').fadeOut('slow');
        });

        /**
         * Music popup
         */

        $('.music-item .get-button').each(function() {
            $(this).on('click', function() {
                let blockId = $(this).data('block-id');
                
                $('.music-section-overlay').fadeIn();
                $('.get-music-product--' + blockId).fadeIn();
            });
        });

        $('.music-section .close-button').on('click', function() {
            $('.music-section').fadeOut('slow');
        });

        $('.music-section .product-close-button').on('click', function() {
            $('.get-music-product-popup').fadeOut('slow');
            $('.music-section-overlay').fadeOut('slow');

            var $audioElement = $(this).next().find('.preview-music')[0];
            var $currentTime = $(this).next().find('.product-image-wrapper .current-time');

            $audioElement.pause();
            $audioElement.currentTime = 0;
            $currentTime.text('00:00');
            $('.controls .stop-button').hide();
            $('.controls .play-button').show();
            $currentTime.hide();
        });

        function formatTime(seconds) {
            var minutes = Math.floor(seconds / 60);
            var remainingSeconds = Math.floor(seconds % 60);
            return (minutes < 10 ? '0' : '') + minutes + ':' + (remainingSeconds < 10 ? '0' : '') + remainingSeconds;
        }

        $('.controls .play-button').each(function() {
            var $audioElement = $(this).parent().parent().next()[0]
            var $currentTime = $(this).parent().next();

            $(this).on('click', function() {
                $(this).hide();
                $(this).next().show();

                $currentTime.fadeIn('slow');
                $audioElement.play();
            });

            $audioElement.ontimeupdate = function() {
                var currentTimeInSeconds = $audioElement.currentTime;
                $currentTime.text(formatTime(currentTimeInSeconds));
            };
        });

        $('.controls .stop-button').each(function() {
            var $audioElement = $(this).parent().parent().next()[0]
            var $currentTime = $(this).parent().next();

            $(this).on('click', function() {
                $(this).hide();
                $(this).prev().show();

                $currentTime.fadeOut('slow');
                $audioElement.pause();
            });
        });

        /**
         * Video popup
         */
        $('.video-section .close-button').on('click', function() {
            $('.video-section').fadeOut('slow');
        });

        $('.video-item-image').each(function() {
            $(this).on('click', function() {
                $('.video-section .overlay').fadeIn();
                $(this).next('.video-popup-wrapper').fadeIn();
            });
        });

        $('.video-popup-wrapper .pupup-close-button').on('click', function() {
            $('.video-popup-wrapper').fadeOut();
            $('.video-section .overlay').fadeOut();
        });

        /**
         * Ticket on sale popup
         */
        if ($('.ticket-on-sale-popup')) {
            setTimeout(function() {
                $('.ticket-popup-overlay').fadeIn();
                $('.ticket-on-sale-popup').fadeIn();
            }, 3000)
        }

        $('.ticket-on-sale-popup .close-button').on('click', function() {
            $('.ticket-on-sale-popup').fadeOut();
            $('.ticket-popup-overlay').fadeOut();
        })

        /**
         * Header
         */
        $(window).scroll(function() {
            if($(document).scrollTop() > 0) {
                $('.header-wrapper').css('background', '#fff');
                $('.header__menu-item').css('color', '#121212');
                $('.header__heading-link .h2').css('color', '#121212');
                $('.header__icon svg path').css('fill', '#121212');
                $('img.header__heading-logo').css('filter', 'brightness(1) invert(0.8)');
                $('.header__active-menu-item').css('color', '#910800');
            } else {
                $('.header-wrapper').css('background', 'transparent');
                $('.header__menu-item').css('color', '#fff');
                $('.header__heading-link .h2').css('color', '#fff');
                $('.header__icon svg path').css('fill', '#fff');
                $('img.header__heading-logo').css('filter', 'unset');
                $('.header__active-menu-item').css('color', '#fff');
            }
        })

        /**
         * Show info in product template
         */

        $('.product-special-infos .info-item').each(function(index) {
            $(this).on('click', function() {
                
                var dataIInfo = $(this).data('info');

                $('.product-infos-modal').addClass('hidden');
                $('.product-infos-modal__wrapper').addClass('hidden');
                $('.product-infos-modal--overlay').addClass('hidden');

                $('.product-infos-modal').each(function(index) {
                    if($(this).data('info') == dataIInfo) {
                        $(this).removeClass('hidden');
                        $('.product-infos-modal__wrapper').removeClass('hidden');
                        $('.product-infos-modal--overlay').removeClass('hidden');
                    }
                });
            });
        });

        $('.product-infos-modal .close-modal').on('click', function() {
            $('.product-infos-modal').addClass('hidden');
            $('.product-infos-modal__wrapper').addClass('hidden');
            $('.product-infos-modal--overlay').addClass('hidden');
        });

        /**
         * Custom tabs in product template
         */
        $('.Product__Tabs .Collapsible__Button').on('click', function() {
            $(this).toggleClass('active');
            $(this).next().toggleClass('active');

            if ($(this).hasClass('active')) {
                $(this).next().slideDown();
            } else {
                $(this).next().slideUp();
            }
        });

        /**
         * FAQs section
         */
        $('.faqs-wrapper .Collapsible__Button').on('click', function() {
            $(this).toggleClass('active');
            $(this).next().toggleClass('active');

            if ($(this).hasClass('active')) {
                $(this).next().slideDown();
            } else {
                $(this).next().slideUp();
            }
        });
    });
})(jQuery);